export enum ClientType {
  Broker = 'Broker',
  Agent = 'Agent',
  Dealer = 'Dealer',
  DealerGroup = 'Dealer Group',
  Producer = 'Producer',
}
